import {
  Activity,
  AlertTriangle,
  ArrowLeftRight,
  BookOpen,
  BookOpenText,
  Bot,
  CalendarCheck,
  CalendarClock,
  Building2,
  Car,
  Cpu,
  CreditCard,
  Database,
  FileText,
  Gauge,
  Inbox,
  LayoutDashboard,
  Mail,
  Map,
  Mic,
  Receipt,
  Scale,
  Radar,
  ScanFace,
  Send,
  Server,
  Settings,
  ShieldCheck,
  Smartphone,
  Hourglass,
  Sparkles,
  TrendingUp,
  Truck,
  Users,
} from 'lucide-react';

export const ADMIN_NAV_LINKS = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true, group: 'overview' },
  { to: '/ops', icon: Activity, label: 'Live-Betrieb', group: 'overview' },
  { to: '/livemap', icon: Map, label: 'Live-Karte', group: 'overview' },
  { to: '/location-trust', icon: ShieldCheck, label: 'Standort-Evidenz', anyPerm: ['location_trust.view', 'location_trust.manage', 'location_trust.appeal', 'location_trust.config'], group: 'overview' },
  { to: '/driver-radar', icon: Radar, label: 'Fahrer-Radar', anyPerm: ['driver_radar.view', 'driver_radar.manage'], group: 'overview' },

  { to: '/support', icon: Inbox, label: 'Support', end: true, group: 'ops' },
  { to: '/support/nachrichten', icon: Send, label: 'Nachrichten senden', group: 'ops' },
  { to: '/support/faq-luecken', icon: BookOpenText, label: 'FAQ-Lücken', group: 'ops' },
  { to: '/rides', icon: Car, label: 'Fahrten', group: 'ops' },
  // RESERVIERUNG-KOMPLETT-001 (Owner 16.10.2026): eigener Reiter, nicht mehr unter „Fahrten“.
  { to: '/reservierungen', icon: CalendarClock, label: 'Reservierungen', group: 'ops', badgeKey: 'reservierungen' },
  // ADMIN-FAHRT-ZUWEISUNG-001 (Owner 11.09.2026): Dispatch-Platz — Sofortfahrten zuweisen/übergeben.
  { to: '/dispatch', icon: ArrowLeftRight, label: 'Zuweisung', group: 'ops' },
  { to: '/order-log', icon: BookOpen, label: 'Auftragsbuch', group: 'ops' },

  { to: '/users', icon: Users, label: 'Kunden', group: 'people' },
  { to: '/account-protection', icon: ShieldCheck, label: 'Kontoschutz', anyPerm: ['account_protection.view', 'account_protection.manage'], group: 'people' },
  { to: '/drivers', icon: Truck, label: 'Fahrer', group: 'people', badgeKey: 'fahrer' },
  { to: '/partners', icon: Building2, label: 'Partner', group: 'people', badgeKey: 'partner' },
  { to: '/vehicles-admin', icon: Car, label: 'Fahrzeuge', group: 'people', badgeKey: 'fahrzeug' },
  { to: '/verifications', icon: ScanFace, label: 'Verifizierung', perm: 'freigaben.manage', group: 'people', badgeKey: 'selfie' },
  { to: '/documents', icon: FileText, label: 'Dokumente', perm: 'freigaben.manage', group: 'people' },
  // FAHRER-KI-BACKEND-001 (Teil B): Ablaufdaten der Fahrerdokumente gegen das gelesene Dokument prüfen.
  { to: '/documents/ablaufdaten', icon: CalendarCheck, label: 'Ablaufdaten prüfen', perm: 'freigaben.manage', group: 'people' },

  // ADMIN-UX-HEUTE-AKTEN-EINHEIT-001 (Owner 30.08.2026): „Finanzen & Pricing" geteilt —
  // Geld-Themen (was aufs Konto wirkt) getrennt von Steuerungs-Themen (was Preise/Zuteilung regelt).
  { to: '/finance', icon: TrendingUp, label: 'Finanzen', perm: 'finance.manage', group: 'money' },
  { to: '/bonus', icon: Sparkles, label: 'Bonus', anyPerm: ['settings.manage', 'finance.manage'], group: 'money' },
  { to: '/payouts', icon: CreditCard, label: 'Abrechnung', perm: 'finance.manage', group: 'money' },
  // STRIPE-AUFSTOCKUNG-ADMIN-001 (Owner 12.09.2026): offene Karteneinzüge sichtbar und anstoßbar,
  // ohne Terminal/SSH.
  { to: '/settlements', icon: Hourglass, label: 'Zahlungsabschlüsse', perm: 'finance.manage', group: 'money' },
  // GELD-SICHTBARKEIT-001 (Owner-Vorgabe 14.08.2026): eigener Bereich für Kundenbelege je Fahrt.
  { to: '/invoices', icon: Receipt, label: 'Rechnungen', perm: 'finance.manage', group: 'money' },

  { to: '/engine', icon: Cpu, label: 'Engine', anyPerm: ['settings.manage', 'engine.manage'], group: 'steering' },
  { to: '/pulse', icon: Activity, label: 'PULSE', anyPerm: ['settings.manage', 'engine.manage', 'engine.view'], group: 'steering' },
  { to: '/ultimate-v2', icon: Gauge, label: 'Ultimate Pricing V2', anyPerm: ['settings.manage', 'engine.manage', 'engine.view'], group: 'steering' },
  { to: '/agent', icon: Bot, label: 'KI-Agent', anyPerm: ['agent.view', 'agent.manage', 'settings.manage'], group: 'steering' },
  { to: '/route-dispatch', icon: Map, label: 'Route & Dispatch', perm: 'settings.manage', group: 'steering' },

  { to: '/settings', icon: Settings, label: 'Einstellungen', perm: 'settings.manage', group: 'system' },
  { to: '/legal', icon: Scale, label: 'Rechtstexte', perm: 'settings.manage', group: 'system' },
  // MAIL-VORLAGEN-001: Texte aller E-Mails an Kunden, Fahrer und Partner — ohne Deploy änderbar.
  { to: '/mail-templates', icon: Mail, label: 'E-Mail-Vorlagen', perm: 'settings.manage', group: 'system' },
  { to: '/app-gate', icon: Smartphone, label: 'App-Steuerung', perm: 'settings.manage', group: 'system' },
  // ADMIN-CHATVOICE-UI-001: `perm: '*'` = ausschliesslich der Owner. Die Route
  // (PATCH /api/admin/chat-voice/config) ist serverseitig NICHT delegierbar und antwortet jedem
  // anderen Admin mit 403. Ein Menueeintrag, der ins 403 fuehrt, waere kein Erlebnis — also
  // erscheint er erst gar nicht. `hasPermission(perms, '*')` ist genau dann wahr, wenn '*' gesetzt
  // ist; eine ueber /admin/admins vergebene Einzelberechtigung genuegt nie.
  { to: '/chat-voice', icon: Mic, label: 'Chat & Sprache', perm: '*', group: 'system' },
  { to: '/system', icon: Server, label: 'Wartung', group: 'system' },
  { to: '/errors', icon: AlertTriangle, label: 'Fehler-Monitoring', group: 'system' },
  { to: '/data', icon: Database, label: 'Daten-Explorer', perm: 'data.explore', group: 'system' },
  { to: '/assistant', icon: Sparkles, label: 'Support-KI', group: 'system' },
  { to: '/team', icon: ShieldCheck, label: 'Team & Rechte', perm: 'admins.manage', group: 'system' },
];

export const ADMIN_NAV_GROUPS = [
  { id: 'overview', label: 'Überblick' },
  { id: 'ops', label: 'Operativ' },
  { id: 'people', label: 'Nutzer & Partner' },
  { id: 'money', label: 'Geld' },
  { id: 'steering', label: 'Preise & Automatik' },
  { id: 'system', label: 'System & Sicherheit' },
];

// Rechte-Semantik an EINER Stelle (vorher inline in App.js): '*' ist der Owner-Vollzugriff.
// Damit bedeutet `perm: '*'` an einem Nav-Eintrag beweisbar „nur der Owner".
export const hasPermission = (permissions, perm) => {
  const list = Array.isArray(permissions) ? permissions : [];
  return list.includes('*') || list.includes(perm);
};

// Sichtbare Navigation fuer einen Rechte-Pruefer — identisches Verhalten wie zuvor in App.js,
// jetzt aber pruefbar (Menueeintraege duerfen nicht erst nach dem Klick scheitern).
export const visibleNavLinks = (links, can) => links.filter((item) => (
  item.anyPerm
    ? item.anyPerm.some((perm) => !!(can && can(perm)))
    : item.perm
      ? !!(can && can(item.perm))
      : true
));

export const filterNavigation = (links, query) => {
  const normalized = String(query || '').trim().toLocaleLowerCase('de');
  return normalized
    ? links.filter((item) => item.label.toLocaleLowerCase('de').includes(normalized))
    : links;
};
